import { render, staticRenderFns } from "./UserPrivacyAgreement.vue?vue&type=template&id=fde56f30&scoped=true"
import script from "./UserPrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./UserPrivacyAgreement.vue?vue&type=script&lang=js"
import style0 from "./UserPrivacyAgreement.vue?vue&type=style&index=0&id=fde56f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde56f30",
  null
  
)

export default component.exports